export default __webpack_public_path__ + "static/media/Mouse.bf27a130.jpg";